import { render } from "./action-share-qr.vue?vue&type=template&id=2e44f397"
import script from "./action-share-qr.vue?vue&type=script&lang=js"
export * from "./action-share-qr.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/miqrositio/miqrositio_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__